module.exports = __webpack_public_path__ + "static/fonts/Robotothin.a11d03f.woff";